import apiClient from 'hub-http/clients/apiClient';
export const fetchPaymentsAccountEligibility = () => apiClient.get('payments/v1/payment-accounts/eligibility');